var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageAccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.313 4.063V2.188c0-1.036.839-1.876 1.875-1.876h1.874M14.688 4.063V2.188c0-1.036-.84-1.876-1.876-1.876h-1.874M.313 10.938v1.874c0 1.036.839 1.876 1.875 1.876h1.874M14.688 10.938v1.874c0 1.036-.84 1.876-1.876 1.876h-1.874M7.813 5v2.813c0 .517-.42.937-.938.937h-.313M4.688 5L4.688 6.563M10.938 5L10.938 6.563M5.146 10.625c1.32 1.25 3.388 1.25 4.708 0",
    transform: "translate(1 1.107)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageAccess);
export default __webpack_public_path__ + "static/media/manage-access.acf76d0e7270f15ce4c4a9826b5f0405.svg";
export { ForwardRef as ReactComponent };